var _path, _g, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStableCoin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 103,
    viewBox: "0 0 102 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.465 44.0716C105.507 72.2131 86.1884 98.3531 58.318 102.455C30.4476 106.557 4.57655 87.0591 0.534529 58.9177C-3.50749 30.7762 15.8116 4.63612 43.682 0.545214C71.5524 -3.55669 97.4235 15.9301 101.465 44.0716Z",
    fill: "url(#paint0_radial_5031_7274)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M89.2737 44.6212C89.0456 44.6652 88.6327 42.9826 87.5896 40.0904C86.5356 37.2202 84.7536 33.1073 81.4396 28.8184C79.788 26.685 77.767 24.5076 75.3331 22.4951C72.8883 20.5046 70.0633 18.6351 66.847 17.1835C65.2389 16.4467 63.5547 15.7979 61.7836 15.292C60.0126 14.7751 58.1763 14.3463 56.2856 14.1043C54.395 13.8514 52.4501 13.7084 50.4725 13.7634C48.495 13.8074 46.5066 14.0054 44.5073 14.3463C42.508 14.7202 40.5739 15.237 38.705 15.8749C36.8361 16.5127 35.0542 17.3265 33.3591 18.2172C31.6641 19.108 30.0777 20.1417 28.6 21.2414C27.1114 22.3301 25.7423 23.5398 24.4928 24.7825C21.9719 27.2678 19.9509 30.0061 18.3319 32.7334C16.7347 35.4716 15.5721 38.2209 14.7463 40.7942C13.1056 45.9738 12.8339 50.4606 12.8122 53.5178C12.8122 56.597 13.0078 58.3235 12.7687 58.3565C12.5949 58.3895 12.019 56.729 11.6496 53.5838C11.3127 50.4496 11.2475 45.7539 12.7144 40.2004C13.4533 37.4291 14.5616 34.4709 16.1697 31.5017C17.7995 28.5435 19.8857 25.5633 22.537 22.836C23.8626 21.4724 25.2968 20.1527 26.8832 18.954C28.4587 17.7444 30.1538 16.6007 31.9792 15.6219C33.7938 14.6432 35.7061 13.7524 37.7271 13.0486C39.7373 12.3448 41.8343 11.7839 43.9857 11.3881C46.1371 11.0142 48.2994 10.8162 50.4291 10.7722C52.5587 10.7282 54.6558 10.9042 56.6985 11.1901C58.7413 11.476 60.7188 11.9599 62.6094 12.5427C64.5109 13.1146 66.3146 13.8514 68.0097 14.6762C71.4323 16.3147 74.3987 18.3822 76.9412 20.5926C79.462 22.825 81.5157 25.2224 83.1455 27.5537C86.4161 32.2495 87.959 36.6923 88.7087 39.7495C89.4258 42.8287 89.4476 44.5882 89.2737 44.6212Z",
    fill: "url(#paint1_radial_5031_7274)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5518 57.2462C12.5626 57.2462 12.5952 57.3452 12.6496 57.5541C12.7039 57.7961 12.7799 58.093 12.8669 58.4669C12.9538 58.8848 13.0625 59.3797 13.1928 59.9515C13.3232 60.5344 13.4427 61.2162 13.7035 61.953C14.5293 64.9442 16.1592 69.2 19.2993 73.7528C20.8314 76.0512 22.885 78.2946 25.232 80.516C25.8622 81.0329 26.4924 81.5498 27.1443 82.0776C27.4703 82.3415 27.7854 82.6275 28.1331 82.8694C28.4808 83.1113 28.8394 83.3423 29.1979 83.5842C29.9151 84.0571 30.6213 84.5849 31.3819 85.0138C32.1642 85.4317 32.9466 85.8606 33.7398 86.2895C36.9995 87.8621 40.596 89.2147 44.4859 89.8415C48.3758 90.4684 52.483 90.5454 56.6228 89.9845C60.7517 89.3137 64.6634 88.038 68.2056 86.2895C71.7586 84.552 74.8119 82.1986 77.4848 79.7462C78.1259 79.0974 78.7561 78.4596 79.3755 77.8327C79.9839 77.1949 80.5055 76.4801 81.0596 75.8203C81.3313 75.4904 81.6029 75.1495 81.8746 74.8195C82.1353 74.4786 82.3526 74.1157 82.5917 73.7748C83.0589 73.082 83.5153 72.3892 83.9716 71.7184C85.5906 68.9031 86.9053 66.1539 87.7203 63.5036C89.4153 58.225 89.763 53.6722 89.7087 50.571C89.7521 49.7902 89.6652 49.1084 89.6218 48.5036C89.5783 47.9207 89.5348 47.4149 89.5131 46.986C89.4914 46.6121 89.4696 46.3041 89.4588 46.0512C89.4479 45.8423 89.4479 45.7323 89.4588 45.7323C89.4696 45.7323 89.4914 45.8313 89.524 46.0402C89.5566 46.2822 89.6 46.5901 89.6435 46.964C89.6978 47.3929 89.7521 47.8877 89.8173 48.4816C89.8825 49.0754 89.9803 49.7682 89.9586 50.549C90.0998 53.6722 89.8173 58.269 88.1549 63.6355C87.3617 66.3298 86.047 69.1231 84.428 71.9933C83.9716 72.6751 83.5153 73.3789 83.048 74.0937C82.809 74.4456 82.5917 74.8195 82.3309 75.1605C82.0593 75.5014 81.7876 75.8313 81.516 76.1722C80.951 76.843 80.4294 77.5688 79.8209 78.2286C79.1907 78.8775 78.5497 79.5263 77.9086 80.1861C75.2139 82.6934 72.1063 85.0908 68.5098 86.8613C64.9133 88.6319 60.9365 89.9405 56.7532 90.6223C52.5482 91.1942 48.3758 91.1172 44.4207 90.4684C40.4656 89.8195 36.8147 88.4449 33.5116 86.8283C32.7075 86.3885 31.9035 85.9486 31.1211 85.5197C30.3388 85.0688 29.6326 84.53 28.9046 84.0571C28.546 83.8152 28.1874 83.5622 27.8289 83.3203C27.4812 83.0673 27.1661 82.7814 26.8292 82.5175C26.1773 81.9786 25.5362 81.4398 24.906 80.9119C22.5373 78.6465 20.4837 76.3481 18.9516 74.0058C15.8223 69.365 14.2359 65.0322 13.4862 62.008C13.2363 61.2602 13.1385 60.5783 13.0299 59.9845C12.9321 59.4017 12.8343 58.9068 12.7691 58.4889C12.7039 58.115 12.6604 57.8071 12.617 57.5651C12.5518 57.3562 12.5409 57.2572 12.5518 57.2462Z",
    fill: "url(#paint2_radial_5031_7274)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2743 55.0247H70.9774V73.8627C68.4891 75.7652 65.5989 77.2278 62.3283 78.2395C59.0577 79.2512 55.7546 79.7681 52.4297 79.7681C47.6706 79.7681 43.3895 78.7454 39.5865 76.6889C35.7835 74.6325 32.8064 71.7842 30.6441 68.1332C28.4818 64.4822 27.3953 60.3583 27.3953 55.7615C27.3953 51.1647 28.4818 47.0408 30.6441 43.3898C32.8064 39.7388 35.8161 36.8905 39.6517 34.8341C43.4981 32.7776 47.8227 31.7549 52.6253 31.7549C56.6456 31.7549 60.2964 32.4367 63.567 33.8113C66.8484 35.186 69.5974 37.1764 71.8249 39.7827L65.0121 46.15C61.7307 42.653 57.7756 40.9044 53.1468 40.9044C50.224 40.9044 47.6162 41.5203 45.3453 42.763C43.0744 44.0056 41.3033 45.7432 40.032 48.0086C38.7607 50.263 38.1305 52.8473 38.1305 55.7725C38.1305 58.6427 38.7607 61.216 40.032 63.4704C41.3033 65.7248 43.0527 67.4844 45.3127 68.749C47.5619 70.0137 50.1262 70.6405 53.0164 70.6405C56.0697 70.6405 58.8296 69.9807 61.2743 68.6501V55.0247V55.0247Z",
    fill: "url(#paint3_radial_5031_7274)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0753 41.9491C39.0753 41.9491 38.6733 19.4601 63.7186 16.7328C63.7186 16.7328 64.7943 39.4967 39.0753 41.9491Z",
    fill: "url(#paint4_radial_5031_7274)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6181 17.0076C63.6181 17.0076 63.4877 39.8705 39.3442 41.63L63.6181 17.0076Z",
    fill: "url(#paint5_radial_5031_7274)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5031_7274",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.9993 51.4955) scale(50.9409 51.5571)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#220A79",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1722,
    stopColor: "#1D287C",
    stopOpacity: 0.1722
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5482,
    stopColor: "#107485",
    stopOpacity: 0.5482
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D791"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_5031_7274",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.3954 34.5617) scale(32.1828 32.5721)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#220A79",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1722,
    stopColor: "#1D287C",
    stopOpacity: 0.1722
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5482,
    stopColor: "#107485",
    stopOpacity: 0.5482
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D791"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_5031_7274",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.2627 68.3767) scale(31.6122 31.9945)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#220A79",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1722,
    stopColor: "#1D287C",
    stopOpacity: 0.1722
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5482,
    stopColor: "#107485",
    stopOpacity: 0.5482
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D791"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_5031_7274",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.6077 55.7551) scale(22.9827 23.2607)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#220A79",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1722,
    stopColor: "#1D287C",
    stopOpacity: 0.1722
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5482,
    stopColor: "#107485",
    stopOpacity: 0.5482
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D791"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_5031_7274",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.4025 29.3372) scale(12.3914 12.5413)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C790",
    stopOpacity: 0.9208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D791"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_5031_7274",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.479 29.3142) scale(12.15 12.2969)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C790",
    stopOpacity: 0.9208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C092"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStableCoin);
export default __webpack_public_path__ + "static/media/stable-coin.02f766caf4042a8cecb3e03defcb7f1f.svg";
export { ForwardRef as ReactComponent };